import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LoadingInterceptor {

    activeRequests: number = 0;
    progressInterval!: any;
    isglobalComp: boolean = false;

    constructor(
        private loadingService: LoadingService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // O chat (REST do back-end em /chat/..., anexos em /chatv2/...) vive em tempo
        // real: a barra de progresso a cada mensagem só o fazia parecer lento.
        if (request.url.indexOf('/chat/') > -1 || request.url.indexOf('/chatv2/') > -1) {
            return next.handle(request);
        }

        let pages = environment.pagesLoading.filter(page => {
            return request.url.indexOf(page) > -1 && request.url.indexOf('/check') === -1 && !request.params.has('search');
        });

        if (pages.length > 0) {
            this.activeRequests++;
            if (this.activeRequests === 1)
                this.loadingService.startProgressBar();
        }

        return next.handle(request).pipe(
            finalize(() => {
                let pages = environment.pagesLoading.filter(page => {
                    return request.url.indexOf(page) > -1 && request.url.indexOf('/check') === -1 && !request.params.has('search');
                });

                if (pages.length > 0) {
                    this.activeRequests--;
                    if (this.activeRequests === 0) {
                        this.loadingService.stopProgressBar();
                    }

                }


            })
        )
    }


}